import { render, staticRenderFns } from "./ChatAlerts.vue?vue&type=template&id=72ed11d7&scoped=true"
import script from "./ChatAlerts.vue?vue&type=script&lang=js"
export * from "./ChatAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed11d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72ed11d7')) {
      api.createRecord('72ed11d7', component.options)
    } else {
      api.reload('72ed11d7', component.options)
    }
    module.hot.accept("./ChatAlerts.vue?vue&type=template&id=72ed11d7&scoped=true", function () {
      api.rerender('72ed11d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/ChatDialog/ChatAlerts.vue"
export default component.exports